import React from 'react';
import { Chip, Stack } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { CONSENT_STATUS } from '@/features/informedConsent/helpers';

export const CONSENT_STATUS_CHIP_SX = {
	[CONSENT_STATUS.RECEIVED]: {
		backgroundColor: '#d1f0e8',
		color: '#0b624f',
	},
	[CONSENT_STATUS.EXPIRED]: {
		backgroundColor: '#f8d4d6',
		color: '#b91c1c',
	},
	[CONSENT_STATUS.NOT_APPLICABLE]: {
		backgroundColor: '#e8eaed',
		color: '#3c4043',
	},
};

const LABELS = {
	[CONSENT_STATUS.RECEIVED]: 'Received',
	[CONSENT_STATUS.EXPIRED]: 'Expired',
	[CONSENT_STATUS.NOT_APPLICABLE]: 'Not Applicable',
};

export const InformedConsentStatusChip = ({ status }) => {
	const sx = CONSENT_STATUS_CHIP_SX[status];
	const label = LABELS[status];
	const isExpired = status === CONSENT_STATUS.EXPIRED;

	if (!sx || !label) {
		return null;
	}

	return (
		<Stack direction='row' spacing={0.75} alignItems='center'>
			<Chip
				size='small'
				label={label}
				sx={{
					...sx,
					fontWeight: 600,
					textTransform: 'capitalize',
					'& .MuiChip-label': {
						color: sx.color,
						fontWeight: 600,
					},
				}}
			/>
			{isExpired && (
				<ErrorOutlineIcon
					fontSize='small'
					sx={{ color: sx.color, cursor: 'default' }}
				/>
			)}
		</Stack>
	);
};
